/**
 * Notify user when they try and leave a page where they have edited a form
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/off/off.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/traversal/index/index.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/traversal/eq/eq.js";

function isEqual(original, compare) {

	// compare normally if not array
	if (!Array.isArray(original)) {
		if ([null, undefined].indexOf(original) > -1) {
			original = "";
		}
		if ([null, undefined].indexOf(compare) > -1) {
			compare = "";
		}
		return original === compare;

	// check the other value is an array and has same length
	} else if (Array.isArray(compare) && original.length === compare.length) {
		return original.every((value, i) => {
			return i in compare ? isEqual(value, compare[i]) : false;
		});
	}
	return false;
}

export default obj => {
	if (obj.length) {
		const changed = [],
			win = $(window),
			callback = e => {
				e.preventDefault();
				e.returnValue = "";
			};

		// add change listeners, do not bind beforeunload unless necessary
		// https://developers.google.com/web/updates/2018/07/page-lifecycle-api#the-beforeunload-event
		// check each field that has the name attribute, not hidden fields, submit buttons, or any field with data-notify-ignore on it
		$("input[name]:not([type=hidden]):not([type=submit]):not([data-notify-ignore]),textarea[name]:not([data-notify-ignore]),select[name]:not([data-notify-ignore])", obj).on("change", function () {
			let $this = $(this),
				tag = this.tagName.toLowerCase(),
				original,
				checked = ["radio", "checkbox"].indexOf(this.type) > -1,
				current = checked ? $this.filter(":checked").val() : $this.val();

			// get textarea value
			if (tag === "textarea") {
				original = $this.text();

			// get select value
			} else if (tag === "select") {
				if (this.multiple) {
					original = [];
					$("option[selected]", $this).each((i, option) => {
						const obj = $(option),
							val = obj.attr("value");
						if (typeof val === undefined) {
							val = obj.text();
						}
						original.push(val);
					});
				} else {
					const options = $("option[selected]", $this).add("option", this);
					original = options.attr("value");
					if (typeof obj.attr("value") === undefined) {
						original = options.eq(0).text();
					}
				}

			// get input values
			} else {
				original = checked ? $this.filter("[checked]").attr("value") : $this.attr("value");
			}

			// update the changed array
			const index = changed.indexOf(this),
				equal = isEqual(original, current),
				bound = changed.length > 0;

			// add to the changed list
			if (!equal && index < 0) {
				changed.push(this);

			// remove from the changed list
			} else if (equal && index > -1) {
				changed.splice(index, 1);
			}

			// bind the beforeunload event
			const updated = changed.length > 0;
			if (!bound && updated) {
				win.on("beforeunload", callback);
			} else if (bound && !updated) {
				win.off("beforeunload", callback);
			}
		});

		// capture form submit
		obj.on("submit", function () {
			win.off("beforeunload", callback);
		});
	}
};
